import {
  IProfile,
  IProfileEntityDetail,
} from '@boma/supplier-portal/shared/entities';
import { Action, createReducer, on } from '@ngrx/store';
import * as UserActions from './user.actions';

export const USER_FEATURE_KEY = 'user';

export interface UserState extends IProfile {
  selectedOrganizationId: string | null;
  error?: string | null;
  loaded: boolean;
}

export const userIntialState: UserState = {
  selectedOrganizationId: '',
  id: '',
  firstName: '',
  surname: '',
  roles: [],
  updatedAt: null,
  createdAt: null,
  entities: [],
  error: '',
  loaded: false,
};

const usersReducer = createReducer(
  userIntialState,
  on(UserActions.loadUserSuccess, (state, { payload }) => {
    const selectedEntity = localStorage.getItem('selectedEntityId')
      ? localStorage.getItem('selectedEntityId')
      : payload.entities[0].id;
    return {
      ...payload,
      selectedOrganizationId: selectedEntity,
      loaded: true,
    };
  }),
  on(UserActions.loadUserFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(UserActions.setSelectedSupplier, (state, { id }) => ({
    ...state,
    selectedOrganizationId: id,
    loaded: true,
  })),
  on(UserActions.loadEntitySuccess, (state, { payload }) => {
    localStorage.setItem('selectedEntityId', payload.id);

    return {
      ...state,
      entities: state.entities.map((e) =>
        e.id === payload.id ? new IProfileEntityDetail({ ...payload } as Partial<IProfileEntityDetail>, e) : e
      ),
      selectedOrganizationId: payload.id,
      loaded: true,
    };
  })
);

export function userReducer(state: UserState | undefined, action: Action) {
  return usersReducer(state, action);
}
